import { memoize } from "@use/decorators";

import { ElementModelData } from "@courses-pm2/api/src/ts/models/ElementModel";
import { ReactNode } from "react";
import { ContentElementModel } from "./ContentElementModel";

export type GlossaryCollectionWordModel = {
  id: string;
  term: ReactNode;
  definition: ReactNode;
  page?: {
    id: string;
    title?: string;
  };
};

/**
 * Specification of data needed to instantiate a new ElementLinkModel.
 */
type GlossaryCollectionData = {
  [
    K in "title" | "description" | "glossaryWords" | "options"
  ]: GlossaryCollectionModel[K];
};

/**
 * Describes the content to be rendered for the element, so that it's made
 * easily available.
 */
export class GlossaryCollectionModel extends ContentElementModel {
  public readonly title: string;
  public readonly description: string | null;
  public readonly glossaryWords: Array<GlossaryCollectionWordModel>;

  public readonly options: {
    layout: "box-1" | "box-2" | "box-3" | undefined;
    withGraphic: boolean;
  };

  /**
   * Apply data given when a new model is being instantiated.
   */
  constructor(initial: GlossaryCollectionData & ElementModelData) {
    super(initial);

    this.title = initial.title;
    this.description = initial.description;
    this.glossaryWords = initial.glossaryWords;
    this.options = initial.options;
  }

  /**
   * Helper that'll render the title of the slider, adding support for certain
   * simple html tags.
   */
  @memoize()
  public renderTitle(): React.ReactNode {
    return this.title;
  }
  public async getPreviewImageUrl(): Promise<undefined> {
    return undefined;
  }

  public getPreviewText(): string | undefined {
    return undefined;
  }

  /**
   * @inheritdoc
   *
   * Element links are able to contain RichTextNodes, so use the helper from
   * the RichtextModel to calculate standard pages for the content.
   */
  // tslint:disable-next-line: completed-docs
  @memoize()
  public getStandardPageCount(): number {
    return 0;
  }
}
